import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFiltersInPage } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { ProgramTagsFilter } from 'components/common/GlobalFiltersInPage/components/ProgramTagsFilter/programTagsFilter';
import { GlobalFilterFieldKey } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';
import { OverallStatus } from 'components/widgets/OverallStatus/OverallStatus';
import { ProjectScorecards } from 'components/widgets/ProjectScorecards/ProjectScorecards';
import { TimelineAndDensity } from 'components/widgets/timelineAndDensity/timelineAndDensity';

export const PortfolioOverviewPage = () => {
    useFullStoryPageView({ pageName: portfolioConfig.portfolioOverview.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <GlobalFilterButton />
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={portfolioConfig.portfolioOverview.title} />
                    <GlobalFiltersInPage defaultValues={{ [GlobalFilterFieldKey.programTags]: [] }}>
                        <ProgramTagsFilter name={GlobalFilterFieldKey.programTags} />
                    </GlobalFiltersInPage>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <OverallStatus />
                    <ProjectScorecards />
                    <TimelineAndDensity />
                </PageWidgetWrapper>
            </MainContent>
        </PageContainer>
    );
};
